import { render, staticRenderFns } from "./TheLayoutExpiring.vue?vue&type=template&id=20286552"
import script from "./TheLayoutExpiring.vue?vue&type=script&lang=js"
export * from "./TheLayoutExpiring.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutExpiring.vue?vue&type=style&index=0&id=20286552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports